import * as React from 'react';
import {Badge} from 'reactstrap';
import {NavLink} from 'react-router-dom';

interface SidebarLinkProps {
    icon?: string;
    new?: boolean;
    route: string;
    title: string;

    onClick(): any;
}

class SidebarLink extends React.Component<SidebarLinkProps> {
    public render() {
        return (
            <NavLink to={this.props.route} onClick={this.props.onClick}
                     activeClassName='sidebar__link-active'>
                <li className='sidebar__link'>
                    {this.props.icon ? <span className={`sidebar__link-icon lnr lnr-${this.props.icon}`}/> : ''}
                    <p className='sidebar__link-title'>
                        {this.props.title}
                        {this.props.new ? <Badge className='sidebar__link-badge'><span>New</span></Badge> : ''}
                    </p>
                </li>
            </NavLink>
        )
    }
}

export default SidebarLink;


// WEBPACK FOOTER //
// ./src/components/common/layout/sidebar/sidebar-link.tsx